import { render, staticRenderFns } from "./InternsPage.vue?vue&type=template&id=176b4de4&"
import script from "./InternsPage.vue?vue&type=script&lang=js&"
export * from "./InternsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports